import React from 'react'
import { useTDSContext, TDS_DEFAULT_COLORS } from '../../tds/index'
import { spacing, colors } from '../../foundation'

export const FullWidthContent: React.FunctionComponent<
  React.PropsWithChildren<{ className?: string }>
> = ({ children, ...props }) => {
  const { useTDS } = useTDSContext()
  return (
    <div
      css={{
        backgroundColor: useTDS
          ? TDS_DEFAULT_COLORS.colors.systemGrayscale00
          : colors.GRAYSCALE.X10,
      }}
      {...props}
    >
      <div
        css={{
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          padding: spacing.X24,
          gap: spacing.X24,
        }}
      >
        {children}
      </div>
    </div>
  )
}
